<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 13.5V8.5H10.5V13.5M5.5 2.5V5.5H10.5V2.5M2.5 13.5H13.5V4.5L11.5 2.5H2.5V13.5Z"
      stroke="currentColor"
      stroke-linejoin="round" />
  </svg>
</template>
